import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import UserProfile from './UserProfile';
import { useAuth } from '../contexts/AuthContext';
import './FaceSwapHeader.css';

const FaceSwapHeader: React.FC = () => {
  const { isLoggedIn, isLoading } = useAuth();

  return (
    <div className="header-wrapper">
      <header className="face-swap-header">
        <div className="header-container">
          <div className="header-content">
            <Link to="/" className="logo-link">
              <Logo />
            </Link>
            
            {/* Main Navigation Menu */}
            {/* <nav className="main-nav">
              <Link to="/face-swap" className="nav-link active">
                Face Swap
              </Link>
              <Link to="/image-to-video" className="nav-link">
                Video Gen
              </Link>
            </nav> */}
            
            <nav className="header-nav">
              <Link to="/pricing" className="nav-link">
                Pricing
              </Link>
              
              {isLoading ? (
                <div className="login-button loading-state">
                  <span className="loading-dots">···</span>
                </div>
              ) : isLoggedIn ? (
                <UserProfile />
              ) : (
                <Link to="/login" className="login-button">
                  Log in
                </Link>
              )}
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
};

export default FaceSwapHeader;

